import { Link } from 'react-router-dom';

export default function Conclusion() {
  return (
    <section className="py-20 bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-5xl mx-auto px-6">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            結論：どっちがおすすめ？
          </h2>
          <p className="text-gray-600">
            あなたのライフスタイルに合わせて最適な1枚を選びましょう
          </p>
        </div>

        <div className="bg-white rounded-2xl shadow-xl border-2 border-gray-200 p-8 md:p-12 mb-12">
          <div className="space-y-8">
            <div className="flex items-start gap-4">
              <div className="w-12 h-12 bg-rose-100 rounded-xl flex items-center justify-center flex-shrink-0">
                <i className="ri-shopping-bag-3-line text-rose-600 text-xl"></i>
              </div>
              <div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">大手ECモール系カードがおすすめな人</h3>
                <p className="text-gray-700 leading-relaxed mb-4">
                  <strong className="text-rose-600">ECモールをよく利用する方、経済圏でポイントを貯めたい方</strong>には大手ECモール系カードが圧倒的におすすめです。基本還元率1.0%で、どこで使ってもポイントが貯まりやすく、ECモールでは最大3倍のポイントが獲得できます。
                </p>
                <p className="text-gray-700 leading-relaxed mb-4">
                  また、審査が比較的やさしいため、初めてクレジットカードを作る方や、審査に不安がある方にも適しています。モバイル、銀行などの関連サービスを複数利用している方は、SPU（スーパーポイントアッププログラム）でさらにお得になります。
                </p>
                <Link
                  to="/rakuten"
                  className="inline-flex items-center gap-2 text-rose-600 hover:text-rose-700 font-bold transition-colors cursor-pointer"
                >
                  大手ECモール系カードの詳細を見る
                  <i className="ri-arrow-right-line"></i>
                </Link>
              </div>
            </div>

            <div className="border-t-2 border-gray-100 pt-8"></div>

            <div className="flex items-start gap-4">
              <div className="w-12 h-12 bg-teal-100 rounded-xl flex items-center justify-center flex-shrink-0">
                <i className="ri-shield-check-line text-teal-600 text-xl"></i>
              </div>
              <div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">三井住友カードがおすすめな人</h3>
                <p className="text-gray-700 leading-relaxed mb-4">
                  <strong className="text-teal-600">コンビニやファストフードをよく利用する方、即日発行したい方</strong>には三井住友カード（NL）がおすすめです。セブン-イレブン、ローソン、マクドナルドなどの対象店舗で最大7%還元が受けられるため、日常的にこれらの店舗を利用する方は大きなメリットがあります。
                </p>
                <p className="text-gray-700 leading-relaxed mb-4">
                  また、最短即日発行が可能なため、急いでカードが必要な方にも最適です。ナンバーレスデザインでセキュリティ面でも安心でき、信頼できる老舗ブランドを選びたい方にもぴったりです。
                </p>
                <Link
                  to="/mitsui"
                  className="inline-flex items-center gap-2 text-teal-600 hover:text-teal-700 font-bold transition-colors cursor-pointer"
                >
                  三井住友カードの詳細を見る
                  <i className="ri-arrow-right-line"></i>
                </Link>
              </div>
            </div>
          </div>
        </div>

        <div className="bg-gradient-to-br from-amber-50 to-orange-50 border-2 border-amber-200 rounded-2xl p-8 md:p-10 mb-12">
          <div className="flex items-start gap-4 mb-6">
            <div className="w-14 h-14 bg-amber-500 rounded-2xl flex items-center justify-center flex-shrink-0">
              <i className="ri-lightbulb-line text-white text-2xl"></i>
            </div>
            <div>
              <h3 className="text-2xl font-bold text-gray-900 mb-2">最終的な選び方のポイント</h3>
              <p className="text-gray-700">迷ったら、この3つの質問で決めましょう</p>
            </div>
          </div>

          <div className="space-y-4">
            <div className="bg-white rounded-xl p-6 border border-amber-200">
              <div className="flex items-center gap-3 mb-2">
                <div className="w-8 h-8 bg-amber-100 rounded-lg flex items-center justify-center">
                  <span className="text-amber-600 font-bold">1</span>
                </div>
                <h4 className="font-bold text-gray-900">ECモールをよく使いますか？</h4>
              </div>
              <p className="text-sm text-gray-600 ml-11">
                <strong>YES</strong> → 大手ECモール系カード ／ <strong>NO</strong> → 次の質問へ
              </p>
            </div>

            <div className="bg-white rounded-xl p-6 border border-amber-200">
              <div className="flex items-center gap-3 mb-2">
                <div className="w-8 h-8 bg-amber-100 rounded-lg flex items-center justify-center">
                  <span className="text-amber-600 font-bold">2</span>
                </div>
                <h4 className="font-bold text-gray-900">コンビニやマクドナルドをよく使いますか？</h4>
              </div>
              <p className="text-sm text-gray-600 ml-11">
                <strong>YES</strong> → 三井住友カード ／ <strong>NO</strong> → 次の質問へ
              </p>
            </div>

            <div className="bg-white rounded-xl p-6 border border-amber-200">
              <div className="flex items-center gap-3 mb-2">
                <div className="w-8 h-8 bg-amber-100 rounded-lg flex items-center justify-center">
                  <span className="text-amber-600 font-bold">3</span>
                </div>
                <h4 className="font-bold text-gray-900">基本還元率を重視しますか？</h4>
              </div>
              <p className="text-sm text-gray-600 ml-11">
                <strong>YES</strong> → 大手ECモール系カード ／ <strong>NO</strong> → 三井住友カード
              </p>
            </div>
          </div>
        </div>

        {/* 4️⃣ 限定感ブロック（キャンペーン情報） */}
        <div className="bg-gradient-to-br from-orange-400 to-orange-500 rounded-2xl p-8 md:p-10 shadow-2xl mb-12">
          <div className="flex items-start gap-4 mb-6">
            <div className="w-14 h-14 bg-white rounded-2xl flex items-center justify-center flex-shrink-0">
              <i className="ri-gift-line text-orange-500 text-2xl"></i>
            </div>
            <div>
              <div className="inline-block bg-white/20 backdrop-blur-sm text-white px-4 py-1 rounded-full text-sm font-bold mb-3">
                期間限定
              </div>
              <h3 className="text-2xl md:text-3xl font-bold text-white mb-2">
                今だけ！新規入会キャンペーン実施中
              </h3>
              <p className="text-white/90 text-sm md:text-base">
                対象カードに新規入会で最大25,600円相当のポイントプレゼント
              </p>
            </div>
          </div>

          <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 mb-6">
            <div className="grid md:grid-cols-3 gap-4 text-center">
              <div>
                <div className="text-3xl font-bold text-white mb-1">最大25,600円</div>
                <div className="text-white/80 text-sm">ポイント特典</div>
              </div>
              <div>
                <div className="text-3xl font-bold text-white mb-1">年会費0円</div>
                <div className="text-white/80 text-sm">永年無料</div>
              </div>
              <div>
                <div className="text-3xl font-bold text-white mb-1">最短10秒</div>
                <div className="text-white/80 text-sm">カード番号発行</div>
              </div>
            </div>
          </div>

          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link
              to="/mitsui"
              className="inline-flex items-center justify-center gap-2 bg-white text-orange-600 font-bold px-8 py-4 rounded-xl hover:bg-gray-50 transition-all duration-300 shadow-lg hover:shadow-xl cursor-pointer whitespace-nowrap"
            >
              <i className="ri-file-list-3-line"></i>
              三井住友カードの詳細
            </Link>
            <Link
              to="/rakuten"
              className="inline-flex items-center justify-center gap-2 bg-orange-600 text-white font-bold px-8 py-4 rounded-xl hover:bg-orange-700 transition-all duration-300 shadow-lg hover:shadow-xl cursor-pointer whitespace-nowrap"
            >
              <i className="ri-shopping-bag-3-line"></i>
              大手ECモール系カードの詳細
            </Link>
          </div>
        </div>

        <div className="text-center">
          <div className="bg-white rounded-2xl shadow-lg p-8 border-2 border-gray-100">
            <h3 className="text-2xl font-bold text-gray-900 mb-4">
              まだ迷っている方へ
            </h3>
            <p className="text-gray-600 mb-6">
              他のクレジットカードも比較してみませんか？
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Link
                to="/ranking"
                className="inline-flex items-center justify-center gap-2 bg-teal-600 hover:bg-teal-700 text-white font-bold px-8 py-4 rounded-xl transition-all duration-300 shadow-md hover:shadow-lg cursor-pointer whitespace-nowrap"
              >
                <i className="ri-trophy-line"></i>
                人気ランキングを見る
              </Link>
              <Link
                to="/comparison"
                className="inline-flex items-center justify-center gap-2 bg-white hover:bg-gray-50 text-teal-600 font-bold px-8 py-4 rounded-xl border-2 border-teal-600 transition-all duration-300 cursor-pointer whitespace-nowrap"
              >
                <i className="ri-file-list-3-line"></i>
                カード比較ツール
              </Link>
            </div>
          </div>
        </div>

        <div className="mt-8 text-center">
          <a
            href="/"
            className="inline-flex items-center gap-2 text-teal-600 hover:text-teal-700 font-medium transition-colors cursor-pointer"
          >
            <i className="ri-home-line"></i>
            トップページに戻る
          </a>
        </div>
      </div>
    </section>
  );
}
